/* eslint-disable @next/next/next-script-for-ga */
"use client";
import useShouldFire from "./hooks/useShouldFire";
import Script from "next/script";

interface IPixelsHeadScripts {
  SMARTLOOK_ID: number | string;
  GA_TRACKING_ID: string;
  GTM_ID: string;
}
const PixelsHeadScripts = ({
  SMARTLOOK_ID,
  GA_TRACKING_ID,
  GTM_ID,
}: IPixelsHeadScripts) => {
  const shouldFire = useShouldFire();
  const OSOSS_GTM_ID = process.env.NEXT_PUBLIC_OSOSS_GTM_ID ?? "";
  if (!shouldFire) return;
  return (
    <>
      {/* Smartlook script tags */}
      {SMARTLOOK_ID && (
        <Script
          strategy="lazyOnload"
          id="SMARTLOOK-head-script"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `   window.smartlook||(function(d) {
              var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
              var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
              c.charset='utf-8';c.src='https://rec.smartlook.com/recorder.js';h.appendChild(c);
            })(document);
            smartlook('init', '${SMARTLOOK_ID}');`,
          }}
        />
      )}
      {/* google analytics  */}
      {GA_TRACKING_ID && (
        <Script
          strategy="lazyOnload"
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
        />
      )}
      {GA_TRACKING_ID && (
        <Script
          strategy="lazyOnload"
          id="gtag-init"
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `,
          }}
        />
      )}
      {/*Google Tag script tags */}
      <Script
        strategy="lazyOnload"
        id="OSOSS-google-tag-head-script"
        dangerouslySetInnerHTML={{
          __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${OSOSS_GTM_ID}');
      `,
        }}
      />
      {GTM_ID && (
        <Script
          strategy="lazyOnload"
          id="google-tag-head-script"
          dangerouslySetInnerHTML={{
            __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `,
          }}
        />
      )}
    </>
  );
};
export default PixelsHeadScripts;
